import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, '')}${path}`
  }
  return path
}

export interface ContractorCompany {
  companyId: string
  companyName: string
  taxId?: string | null
  contactPerson?: string | null
  contactPhone?: string | null
  isActive: boolean
}

export interface ContractorWorker {
  workerId: string
  companyId: string
  companyName: string
  fullName: string
  username?: string | null
  jobRole: string
  status: string
  cardNumber?: string | null
  nationalId?: string | null
  company?: string | null
  orgName?: string | null
  position?: string | null
  imageType?: string | null
  imagePath?: string | null
}

export interface PagedResult<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface ContractorQueryParams {
  tenantId?: string
  search?: string
  pageNumber?: number
  pageSize?: number
}

export interface WorkerQueryParams extends ContractorQueryParams {
  companyId?: string | null
}

// Contractor directory lookups used by the worker selection dialog.
// Backed by SQL views uv_PTW_getCompanies / uv_PTW_getWorkers (ผ่าน API /api/v1/contractors/*) เพื่อให้ข้อมูลตรงกับระบบ PTW กลาง
export async function getContractorCompanies(
  params: ContractorQueryParams,
): Promise<PagedResult<ContractorCompany>> {
  const requestParams: Record<string, string | number> = {}
  if (params.tenantId && params.tenantId.trim()) {
    requestParams.tenantId = params.tenantId.trim()
  }
  if (params.search && params.search.trim()) {
    requestParams.search = params.search.trim()
  }
  if (typeof params.pageNumber === 'number') {
    requestParams.pageNumber = params.pageNumber
  }
  if (typeof params.pageSize === 'number') {
    requestParams.pageSize = params.pageSize
  }

  const response = await axios.get<PagedResult<ContractorCompany>>(buildUrl('/api/v1/contractors/companies'), {
    params: requestParams,
  })

  const data = response.data
  return {
    items: data.items ?? [],
    pageNumber: data.pageNumber ?? params.pageNumber ?? 1,
    pageSize: data.pageSize ?? params.pageSize ?? 20,
    totalItems: data.totalItems ?? 0,
    totalPages: data.totalPages ?? 0,
  }
}

export async function getContractorWorkers(
  params: WorkerQueryParams,
): Promise<PagedResult<ContractorWorker>> {
  const requestParams: Record<string, string | number> = {}
  if (params.tenantId && params.tenantId.trim()) {
    requestParams.tenantId = params.tenantId.trim()
  }
  if (params.search && params.search.trim()) {
    requestParams.search = params.search.trim()
  }
  if (params.companyId) {
    requestParams.companyId = params.companyId
  }
  if (typeof params.pageNumber === 'number') {
    requestParams.pageNumber = params.pageNumber
  }
  if (typeof params.pageSize === 'number') {
    requestParams.pageSize = params.pageSize
  }

  const response = await axios.get<PagedResult<ContractorWorker>>(buildUrl('/api/v1/contractors/workers'), {
    params: requestParams,
  })

  const data = response.data
  return {
    items: data.items ?? [],
    pageNumber: data.pageNumber ?? params.pageNumber ?? 1,
    pageSize: data.pageSize ?? params.pageSize ?? 20,
    totalItems: data.totalItems ?? 0,
    totalPages: data.totalPages ?? 0,
  }
}
